define("ember-data/adapter", ["exports", "@ember-data/adapter"], function (_exports, _adapter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _adapter.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"@ember-data/adapter"eaimeta@70e063a35619d71f
});